module.exports = __webpack_public_path__ + "img/right_openla.4122189a.png";